"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRGB = void 0;

/**
 * Calculates the rgb values of a hex code
 *
 * @param hex hex code, can be EITHER `#nnnnnn` or `nnnnnn`
 *
 * @returns rgb values in [r, g, b]
 */
var hexToRGB = function hexToRGB(hex) {
  var parsedHex = hex[0] === "#" ? hex.substr(1) : hex;
  return [parseInt(parsedHex.substr(0, 2), 16), parseInt(parsedHex.substr(2, 2), 16), parseInt(parsedHex.substr(4, 2), 16)];
};

exports.hexToRGB = hexToRGB;